export const serverApi: string = `${process.env.REACT_APP_API_URL}`;
